import React, { useEffect, useState } from 'react'
import { loadStripe } from '@stripe/stripe-js'
import { Elements, PaymentElement } from '@stripe/react-stripe-js'
import { useNavigate } from 'react-router-dom'
import {
  GenrateMatch,
  getPlayerSports,
  withdrawalSlotsAPI,
  FetchEnrolledHoldSlotData
} from '../../API/player'
import { useSnackbar } from 'notistack'
import CheckoutForm from './Checkout'
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CButton,
  CModalFooter
} from '@coreui/react'

// live keys
const stripePromise = loadStripe(
 "pk_live_51PvJorDV2kXyGnEauVG3qgFFeHSQQv8FLikRMX8gu76ReaQ5HZjdm1WcXylNxMUVPGbd0I071AquAV1RQZ6TPWQ100d4daWQMU"
)
// test keya 
// const stripePromise = loadStripe(
//   "pk_test_51PvJorDV2kXyGnEapFQyuHn70HocvHlFBGspcIjsCN6My34t2jV6sICofNTPeqJ8elCBuR0DimW6vCwJV2wpdhPb00naKcKAJK"
//  )
 
const PaymentModal = ({
  waitListPlayer,
  visible,
  onClose,
  clientSecret,
  sports,
  waitList,
  slotID,
  tokenValue,
  TeamChange,
  SelectedTeam
}) => {
  console.log('slotID payment modal', slotID)
  console.log("update team payment modal", TeamChange)
  console.log("update SelectedTeam payment modal", SelectedTeam)


  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  let navigate = useNavigate()
  const [isDisabled, setIsDisabled] = useState(false)
  const [countdown, setCountdown] = useState('')

  var participantId = ''
  var tournamentId = ''

  useEffect(() => {
    let intervalId

    const callAPI = async () => {
      if (slotID == null) {
        console.log("slot is null");
        let slotres = await FetchEnrolledHoldSlotData()
        if (slotres.status) {
          const holdTime = new Date(slotres.data.hold_time)
          const currentTime = new Date()
          const timeDifference = holdTime - currentTime

          if (timeDifference > 0) {
            intervalId = setInterval(() => {
              const now = new Date()
              const difference = holdTime - now

              if (difference <= 0) {
                clearInterval(intervalId)
                setCountdown(null)
              } else {
                const minutes = Math.floor(
                  (difference % (1000 * 60 * 60)) / (1000 * 60)
                )
                const seconds = Math.floor((difference % (1000 * 60)) / 1000)
                setCountdown(`${minutes}m ${seconds}s`)
              }
            }, 1000)
          } else {
            visible = false;
            setCountdown(null)
          }
        }
      } else {
        let formData = {
          document_id: slotID
        }
        let slotres = await withdrawalSlotsAPI(formData)
        if (slotres.data.status) {
          const holdTime = new Date(slotres.data.data.hold_time)
          const currentTime = new Date()
          const timeDifference = holdTime - currentTime

          if (timeDifference > 0) {
            intervalId = setInterval(() => {
              const now = new Date()
              const difference = holdTime - now

              if (difference <= 0) {
                clearInterval(intervalId)
                setCountdown(null)
              } else {
                const minutes = Math.floor(
                  (difference % (1000 * 60 * 60)) / (1000 * 60)
                )
                const seconds = Math.floor((difference % (1000 * 60)) / 1000)
                setCountdown(`${minutes}m ${seconds}s`)
              }
            }, 1000)
          } else {
            setCountdown(null)
          }
        }
      }

    }

    callAPI()

    return () => clearInterval(intervalId) // Clear the interval on component unmount
  }, [visible])

  const initializeStripe = async () => {
    const stripe = await stripePromise
    const options = {
      clientSecret: clientSecret,
      appearance: {}
    }
  }
  if (visible && clientSecret) {
    initializeStripe()
  }
  const handelSubmit = async () => {
    setIsDisabled(true)
    const sportsArray = []
    let res = await getPlayerSports()
    if (res.status) {
      tournamentId = res.data[0].tournament_id
      participantId = res.data[0].player_id
      res.data.forEach(data => {
        sportsArray.push(data.sports)
      })
    } else {
      enqueueSnackbar('unable to fetch sports', {
        variant: 'error', action: (key) => (
          <button className='toast_close_btn'
            onClick={() => {
              // Close the Snackbar
              closeSnackbar(key);
            }}
          >
            X
          </button>
        ),
      })
    }

    if (sportsArray.length > 0) {
      let formData = {
        tournament_id: tournamentId,
        participant_id: participantId,
        badminton: sportsArray.includes('badminton') ? 'true' : 'false',
        table_tenis: sportsArray.includes('tennis') ? 'true' : 'false'
      }
      let res = await GenrateMatch(formData)
      if (res.status) {
        //remove player from waitlist
        enqueueSnackbar('Welcome to UPG', {
          variant: 'success', action: (key) => (
            <button className='toast_close_btn'
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        })
        navigate('/dashboard')
      } else {
        enqueueSnackbar('unable to genrate match', {
          variant: 'error', action: (key) => (
            <button className='toast_close_btn'
              onClick={() => {
                // Close the Snackbar
                closeSnackbar(key);
              }}
            >
              X
            </button>
          ),
        })
      }
    }
  }
  return (
    <>
      <CModal
        alignment='center'
        visible={visible}
        onClose={onClose}
        aria-labelledby='VerticallyCenteredExample'
      >
        <CModalHeader className=''></CModalHeader>
        <div className='d-flex justify-content-between align-items-center px-3 pt-2'>
          <div>
            <CModalTitle id='VerticallyCenteredExample'>
              Make a Payment
            </CModalTitle>
          </div>
          <div className='badge text-bg-danger text-white fs-6 px-3'>
            {countdown && ` ${countdown}`}
          </div>
        </div>
        <CModalBody>
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            {/* <PaymentElement id="payment-element" /> */}
            <CheckoutForm
              sports={sports}
              waitList={waitList}
              waitListPlayer={waitListPlayer}
              slotID={slotID}
              tokenValue={tokenValue}
              countdown={countdown}
              TeamChange={TeamChange}
              SelectedTeam={SelectedTeam}
            />
          </Elements>
        </CModalBody>
      </CModal>
    </>
  )
}

export default PaymentModal
